import { useState } from 'react';

const useMesSelectionModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const open = (reportData) => {
    setData({ ...reportData, mes: 1 });
    setIsOpen(true);
    setIsLoading(false);
  };

  const close = () => {
    setIsOpen(false);
    setData(null);
    setIsLoading(false);
  };

  const confirm = () => {
    close();
  };

  const updateMes = (mes) => {
    setData(prev => ({ ...prev, mes }));
  };

  const setLoading = (loading) => {
    setIsLoading(loading);
  };

  return {
    show: isOpen,
    data,
    open,
    close,
    confirm,
    updateMes,
    isLoading,
    setLoading,
  };
};

export default useMesSelectionModal;
